import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';

import FuelFarmPage from './FuelFarmPage';
import FuelFarmCreatePage from './FuelFarmCreatePage';

import FuelTankEditForm from '../FuelTanks/FuelTankEditForm';
import FuelTankCreateForm from '../FuelTanks/FuelTankCreateForm';

import CurrentFBO from '../../Services/CurrentFBO';


const FuelFarm = ({ match }) => {
  return (
    <div>
      <Switch>
        <Route path={`${match.url}/create`} component={FuelFarmCreatePage} />
        <Route path={`${match.url}/fueltank/:fuelTankId/edit`} component={FuelTankEditForm} />
        <Route path={`${match.url}/:fuelfarmId/fuelTank/new`} component={FuelTankCreateForm} />
        <Route exect path={`${match.url}`} render={() => (<FuelFarmPage fboId={CurrentFBO.getId()} />)} />
      </Switch>
    </div>
  );
}

export default FuelFarm;



// WEBPACK FOOTER //
// ./src/Containers/FuelFarm/FuelFarmRoutes.js